export default __webpack_public_path__ + "static/media/a037-student-t3-10.f67da668.svg";